import { servicesCollection, rateCardsCollection } from "./firebase";

export const fetchRateCards = async () => {
  const snap = await rateCardsCollection.get();
  return snap.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(), // fetches all fields from the document
  }));
};

export const fetchRateCardById = async (internalId) => {
  if (internalId == null) throw new Error("Missing internal rateCard ID");

  const snapshot = await rateCardsCollection
    .where("id", "==", internalId)
    .limit(1)
    .get();

  if (snapshot.empty)
    throw new Error(`No rate card found for id = ${internalId}`);

  const doc = snapshot.docs[0];
  return { docId: doc.id, ...doc.data() };
};

// Fetch all service groups with roles
export const fetchServices = async () => {
  const snap = await servicesCollection.get();
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};
